// extracted by mini-css-extract-plugin
export var createdDate = "_o1-1";
export var divider = "_o1-2";
export var headerDivider = "_o1-3";
export var messagesCard = "_o1-0";
export var messagesContainer = "_o1-7";
export var messagesContainerWrapper = "_o1-4";
export var pointerCapturingButtonBoxes = "_o1-a";
export var showLeftPanelButton = "_o1-9";
export var showMoreButton = "_o1-c";
export var showMoreButtonContainer = "_o1-b";
export var summaryTitle = "_o1-6";
export var systemMessageCardWrapper = "_o1-d";
export var topButtons = "_o1-8";
export var withPadding = "_o1-5";